/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceMembersBatchDeleteRequest
 */
export interface WorkspaceMembersBatchDeleteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkspaceMembersBatchDeleteRequest
     */
    emails: Array<string>;
}

export function WorkspaceMembersBatchDeleteRequestFromJSON(json: any): WorkspaceMembersBatchDeleteRequest {
    return WorkspaceMembersBatchDeleteRequestFromJSONTyped(json, false);
}

export function WorkspaceMembersBatchDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersBatchDeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function WorkspaceMembersBatchDeleteRequestToJSON(value?: WorkspaceMembersBatchDeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails,
    };
}

